"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPageLanguage = void 0;
const lang_constants_1 = require("./lang.constants");
var EPageLanguage;
(function (EPageLanguage) {
    EPageLanguage["De"] = "DE";
    EPageLanguage["En"] = "EN";
    EPageLanguage["Fr"] = "FR";
    EPageLanguage["Unknown"] = "UNKNOWN";
})(EPageLanguage || (exports.EPageLanguage = EPageLanguage = {}));
//# sourceMappingURL=lang.types.js.map